<template>
	<div class="basket__container">
		<a :href="phpVals.basketUrl" class="flex gap-4 items-center font-bold text-purple whitespace-nowrap"
			v-if="basket.totalItems()">
			<span>
				View your basket (<span data-basket-item-target>{{ basket.totalItems() }}</span><span
					class="sm-only:hidden"> items</span>)
			</span>

			<InlineSvg src="icons/icon-basket.svg" />
		</a>
	</div>
</template>

<script>
import { basket } from "../helpers/products/basket-store.js";
import InlineSvg from "@app/components/InlineSvg.vue";

export default {
	components: { InlineSvg },

	data() {
		return {
			basket,
		};
	},

	computed: {
		phpVals() {
			return window.phpVals;
		},
	},
};
</script>
